package cz.aipsafe.safe.frontend.lang

enum class Language {EN, CS, SK}